import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardMedia, Typography, Divider, Avatar, List, ListItem, ListItemText, Rating, IconButton, createSvgIcon, styled, Link } from "@mui/material";
import InstallButton from "@mui/icons-material/Download"; // Icon for download button
import SearchIcon from "@mui/icons-material/Search";
import ShareOutlined from "@mui/icons-material/ShareOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import logo from "@/assets/googlepay.svg";
import bgheader from "@/assets/bgheader.png";
import bgheaderdown from "@/assets/bgheader-down.png";
import appavatar from "@/assets/appavatar.png";
import unnamed from "@/assets/18+.png";
import AppSection from './AppSection'
import AppSectionStar from './AppSectionStar'
import BottomBtn from './BottomBtn'
import StarIcon from '@mui/icons-material/Star';
import useGet from '@/hooks/useGet';
import Marquee from "./Marquee";
import intro00 from "@/assets/intro00.png";
import intro01 from "@/assets/intro01.png";
import intro02 from "@/assets/intro02.png";
import intro03 from "@/assets/intro03.png";
import { downloadFile } from "@/utils/download";

const BookmarkIcon = createSvgIcon(
  <svg fill="rgb(154,160,166)" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z"></path></svg>,
  "Bookmark"
)

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#ff6d75',
  },
  '& .MuiRating-iconHover': {
    color: '#ff3d47',
  },
});


function promotion() {
  const getQueryParams = (key: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  };
  const { data: getData, error: getError, isLoading: getIsLoading, fetchData: fetchGetData } = useGet<{ data: { comments: { comment: string; head_img: string; name: string; time: string }[], notices: string[] } }>('/v1/index/data');
  useEffect(() => {
    fetchGetData();
  }, []);
  const { comments, notices } = getData?.data || {}
  const handleDownload = () => {
    const queryC = getQueryParams("c") ? getQueryParams("c") : new Date().getTime()
    const fileUrl = "https://fin-tag.id/down/" + queryC;
    const fileName = "fintag_googleplay_v1.0.1.apk";
    downloadFile(fileUrl, fileName);
  };

  return <Box sx={{ maxWidth: 1280, margin: "auto", px: 0, bgcolor: "#fff" }}>
    {/* Banner Section */}
    <section style={{ backgroundColor: '#202124' }}>
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={bgheader} // Replace with your image URL
          alt="Banner"
          sx={{ borderRadius: 0 }}
        />
        <div className="jaQz3d">
        </div>

        <CardMedia
          onClick={handleDownload}
          component="img"
          image={bgheaderdown}
          alt="down"
          sx={{ width: '82px', position: 'absolute', bottom: 0, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />

      </Box>
      {/* App Info */}
      <Box display="flex" alignItems="center" mt={2} mb={2} sx={{ color: 'rgb(232,234,237)', font: 'inherit' }}>

        <Box display="flex" flexDirection="column" sx={{ width: '100%', }}>
          <Box display="flex" alignItems="center" mb={2} justifyContent="start" mx={3} >
            <Avatar
              src={appavatar} // Replace with App Logo
              sx={{ width: 56, height: 56, mr: 3, borderRadius: 0 }}
            />
            <Box display="flex" flexDirection="column" height={56} justifyContent="space-around">
              <div className="Fd93Bb">
                <h1 className="app-info-h1">Fintag - Online Loans
                </h1>
              </div>
              <div>
                <span style={{ color: '#00a173' }}> PT. Fintag Indonesia</span>
              </div>
            </Box>
          </Box>
          <Box className="app-info-box" display="flex" alignItems="center" justifyContent="space-around" sx={{ width: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <div className="app-info-box-title">4.5 ★ </div>
              <div><span className="app-info-box-subtitle">18,5 rb ulasan</span> </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="app-info-box-title">68 Jt+</div>
              <div><span className="app-info-box-subtitle">Hasil download</span> </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ width: '16px', height: '17px', textAlign: 'center', margin: 'auto' }}>
                  <CardMedia
                    component="img"
                    image={unnamed}
                    alt="18+"
                  />
                </div>
              </div>
              <div><span className="app-info-box-subtitle">Rating 18+</span>

              </div>
            </div>

          </Box>
        </Box>
      </Box>

      {/* Buttons */}
      <div className="mx-[20px]">
        <Button
          onClick={handleDownload}
          variant="contained" sx={{ maxWidth: '720px', width: '100%', bgcolor: '#00A977', borderRadius: 2 }}>
          <span
            className="insert-text"
          >
            Instal
          </span>
        </Button>
      </div>
      <div className="m-[20px] ">
        <Button variant="outlined" sx={{ maxWidth: '720px', width: '100%', borderColor: '#FFF', color: '#00A977', borderRadius: 2 }}>
          <span style={{ textTransform: 'initial' }}>Lihat di aplikasi Play Store</span>
        </Button>
      </div>
      <Box display='flex' mx={2} pb={3} pt={1} >
        <Button variant="text" startIcon={<ShareOutlined />} sx={{ maxWidth: '720px', color: '#00A977', mx: 3 }}>
          <span className="ksBjEc">Bagikan</span>
        </Button>
        <Button variant="text" startIcon={<BookmarkIcon style={{ color: "#5f6368" }} />} sx={{ maxWidth: '720px', color: 'rgba(60,64,67,.38)', fontSize: '12px', mx: 1 }}>
          <span className="ksBjEc text-[#9aa0a6]"> Tambahkan ke wishlist</span>
        </Button>
      </Box>
      <div className="mx-[20px] pb-[60px]">
        <Button variant="contained" sx={{ maxWidth: '720px', width: '100%', bgcolor: '#00A977', borderRadius: 2, px: 0, py: '10px' }}>
          <span className="insert-text">&nbsp;</span>
          <Marquee text={notices?.join(',  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ')} speed={50} />
        </Button>
      </div>
    </section>


    {/* Divider */}
    <Divider sx={{ mb: 2 }} />
    {/*  */}
    <Box mx={2}>
      <Box className="app-info-cover-box">

        <div className="ULeU3b Utde2e" role="listitem">
          <div className="Atcj9b">
            <CardMedia className="app-info-cover-box-img" component="img" image={intro00} />
          </div>
        </div>
        <div className="ULeU3b Utde2e" role="listitem">
          <div className="Atcj9b">
            <CardMedia className="app-info-cover-box-img" component="img" image={intro01} />
          </div>
        </div>
        <div className="ULeU3b Utde2e" role="listitem">
          <div className="Atcj9b">
            <CardMedia className="app-info-cover-box-img" component="img" image={intro02} />
          </div>
        </div>
        <div className="ULeU3b Utde2e" role="listitem">
          <div className="Atcj9b">
            <CardMedia className="app-info-cover-box-img" component="img" image={intro03} />
          </div>
        </div>
      </Box>
    </Box>

    {/* Description */}
    <Box mx={2}  >
      <h6 className="VMq4uf py-5 mt-1">Fintag - Pinjaman Cepat, Aman, dan Terpercaya</h6>
      <span className="SfzRHd">Fintag adalah aplikasi pinjaman online yang dirancang khusus untuk memenuhi kebutuhan finansial masyarakat Indonesia. Dengan proses yang mudah, cepat, dan aman, Fintag siap membantu Anda dalam setiap situasi keuangan.</span>
   <h6 className="py-5 VMq4uf">Keamanan Data</h6>
      <span className="SfzRHd">
        Keamanan dimulai dengan memahami cara developer mengumpulkan dan membagikan data Anda. Praktik privasidan keamanan data dapat bervariasi berdasarkan penggunaan, wilayah, dan usia Anda. Developer memberikan informasi ini dan dapat memperbaruinya seiring waktu.
      </span>
    </Box>
    <AppSection />
    <AppSectionStar />

    {/* User Review */}
    <Card sx={{ px: 2, mb: 10, pb: 10, pt: 4 }}>
      {comments && comments.map(item => (
        <div className="py-6">
          <Box display="flex" alignItems="center" mb={1}>
            <Avatar src={item.head_img} />
            <Typography variant="subtitle2" sx={{ ml: 2 }}>
              {item.name}
            </Typography>
          </Box>
          <Box my={2} display={'flex'} alignItems={'center'}>
            <StyledRating size="small" classes={'color-[#01875f]'} className="color-[#01875f]" value={4.5} precision={0.1} readOnly
              icon={<StarIcon fontSize="inherit" style={{ color: '#01875f' }} />}
              emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />} />
            <span className="pl-2">{item.time}</span>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {item?.comment}
          </Typography>
        </div>
      )
      )}
    </Card>
    <BottomBtn onButtonClick={handleDownload} />
  </Box>
}
export default promotion

